import './Form.scss'
import classNames from 'classnames'

interface FormProps {
  className?: string,
  onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
  children: React.ReactNode;
  style?: React.CSSProperties
}

function Form({ className, onSubmit, children, style }: FormProps) {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    onSubmit?.(e)
  }

  return (
    <form
      className={classNames('form', className)}
      style={style}
      onSubmit={handleSubmit}
      noValidate
    >
      {children}
    </form>
  )
}

export default Form
